import React from 'react';
import { Field } from '../../ui/Field';
import { SelectControl } from '../../ui/TextControl';
import { ConsentCheckbox } from '../../ui/ChoiceChip';
import { asDraft } from '../../../types/registration';
import { YEAR_OPTIONS } from '../../../data/registration';
import type { QuestionProps } from './types';
export function YearsQuestion({
  data,
  update
}: QuestionProps) {
  const draft = asDraft(data);
  return <div className="flex flex-col gap-5" data-id="element-468" data-mp="2j6ghyy2g5lyo">
      <div className="grid gap-4 sm:grid-cols-2" data-id="element-469" data-mp="2j5f4kmxyknds">
        <Field name="startYear" label="I arrived in" data-id="element-470" data-mp="2e96vnractqf2">
          <SelectControl id="startYear" name="startYear" placeholder="Choose a year" value={draft.startYear} options={YEAR_OPTIONS} onChange={event => update({
          startYear: event.target.value
        })} data-id="element-471" data-mp="2e6kovtvafexw" />
        </Field>

        <Field name="endYear" label="I left in" hint="Leave blank if you’re not sure." data-id="element-472" data-mp="31vn4yxa9wzqa">
          <SelectControl id="endYear" name="endYear" placeholder="Choose a year" disabled={draft.stillInvolved} value={draft.stillInvolved ? '' : draft.endYear} options={YEAR_OPTIONS} onChange={event => update({
          endYear: event.target.value
        })} data-id="element-473" data-mp="2xubbuhs6xwdc" />
        </Field>
      </div>

      <ConsentCheckbox id="stillInvolved" checked={draft.stillInvolved} onChange={checked => update({
      stillInvolved: checked,
      endYear: checked ? '' : draft.endYear
    })} data-id="element-474" data-mp="1qj1k6pl5yu58">
        I&apos;m still connected today
      </ConsentCheckbox>
    </div>;
}